import { View, Text, Platform, Image } from 'react-native';
import React from 'react';
import { SvgUri } from 'react-native-svg';

const Svg = ({ url, height = 46, width = 46 }: { url: string, height: number, width: number }) => {
  const isSvg = url.endsWith('.svg');

  return (
    <View>
      {isSvg ? (
        Platform.OS === 'web' ? (
          <img
            style={{ width, height }}
            src={url}
            alt="SVG"
          />
        ) : (
          <SvgUri
            height={height}
            width={width}
            uri={url}
          />
        )
      ) : (
        <Image
          style={{ width, height }}
          source={{ uri: url }}
        />
      )}
    </View>
  );
};

export default Svg;